export default __webpack_public_path__ + "static/media/TL10.fbac6dd5.mp3";